module.exports = __webpack_public_path__ + "img/phone_frame.fac97cf.png";